export const maritalStatusTypeConstants = [
  { name: "Unmarried", value: "Unmarried" },
  { name: "Married", value: "Married" },
];
